import type { EnterpriseLearningPathPageFieldsFragment } from 'bundles/enterprise-learning-path-description-page/queries/__generated__/EnterpriseLearningPathPageQuery';
import type { PageConfig } from 'bundles/unified-description-page-common/types/moduleConfig';
import { ModuleNames } from 'bundles/unified-description-page-common/types/moduleConfig';

import _t from 'i18n!nls/enterprise-learning-path-description-page';

type NavigationLink = { name: string; label: string };

export const LEARNING_PATH_NAV_ITEMS = {
  ABOUT: 'about',
  CONTENT: 'content',
};

export function getLearningPathPageNavigationLinks({
  pageData,
  pageConfig,
}: {
  pageData?: EnterpriseLearningPathPageFieldsFragment;
  pageConfig?: PageConfig;
}) {
  const navLinks: Array<NavigationLink> = [];

  const pageConfiguration = pageConfig;

  pageConfiguration?.modules.forEach((moduleConfig) => {
    switch (moduleConfig.name) {
      case ModuleNames.ProductOverview:
        navLinks.push({ name: LEARNING_PATH_NAV_ITEMS.ABOUT, label: _t('About') });
        break;
      case ModuleNames.Syllabus:
        navLinks.push({ name: LEARNING_PATH_NAV_ITEMS.CONTENT, label: _t('Content') });
        break;
      default:
        // no op
        break;
    }
  });

  return navLinks;
}

export const SKILL_PATHWAY_NAV_ITEMS = {
  ABOUT: 'about',
  SKILL_GOALS: 'skill-goals',
  RECOMMENDATIONS: 'recommendations',
};

export const getSkillPathwayNavigationLinks = () => {
  const navLinks: Array<NavigationLink> = [];
  navLinks.push({ name: SKILL_PATHWAY_NAV_ITEMS.ABOUT, label: _t('About') });
  navLinks.push({ name: SKILL_PATHWAY_NAV_ITEMS.SKILL_GOALS, label: _t('Skill goals') });
  navLinks.push({ name: SKILL_PATHWAY_NAV_ITEMS.RECOMMENDATIONS, label: _t('Recommendations') });
  return navLinks;
};
